import React from 'react';
import { GeckoField, GECKO_CONSTS } from 'ui';

const renderOption = (option) => {
  return option.label;
};

const ConversationStatusSelect = ({ value, onChange, multi, placeholder }) => {
  const statuses = [
    {
      label: 'open',
      value: 'open',
    },
    {
      label: 'closed',
      value: 'closed',
    },
    {
      label: 'new',
      value: 'new',
    },
    {
      label: 'no reply',
      value: 'no reply',
    },
  ];

  const field = {
    key: 'value',
    type: multi
      ? GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI
      : GECKO_CONSTS.FIELD_TYPE_SELECT,
    options: [
      {
        options: statuses.map((status) => {
          return {
            status: status,
            label: status.label,
            value: status.value,
          };
        }),
      },
    ],
    optionRenderer: (option) => renderOption(option),
    placeholder: placeholder,
  };

  const handleChange = (_key, value) => {
    onChange(value);
  };
  const values = { value };

  return <GeckoField field={field} values={values} handler={handleChange} />;
};

export default ConversationStatusSelect;
